import { Button, Menu, MenuItem } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import { useMemo, useState, ReactNode } from "react";

type Props<T> = {
  onClick: (value: T) => void;
  selectedValue: T;
  labelText?: string;
  menuItems: { label: ReactNode, value: T }[];
};

export default function WidgetMenuSelector<T>({ onClick, selectedValue, labelText, menuItems }: Props<T>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const menuOpened = Boolean(anchorEl);

  const displayValue = useMemo(() => menuItems?.find(x => x.value === selectedValue)?.label, [menuItems, selectedValue]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (result: T | boolean) => () => {
    setAnchorEl(null);
    if (result) {
      onClick(result as T);
    }
  };

  return (
    <>
      <Button onClick={handleMenuOpen}
        size="small"
        variant="text"
        color="primary"
        sx={{
          bgcolor: "#e0f2f7",
          border: "none",
          boxShadow: "none",
          letterSpacing: "0.1em",
          marginLeft: "25px",
          px: "10px",
          py: "2px",
          fontSize: 11,
          fontWeight: 600,
          borderRadius: 12,
          display: "flex",
          alignItems: "center",
          gap: "4px",
          "&:hover": {
            bgcolor: "#e0f2f7",
            boxShadow: "none",
          },
        }}
      >
        <>
          {labelText ?? displayValue}
          <ArrowDropDownIcon />
        </>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpened}
        onClose={handleMenuClose(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: "left" }}
        slotProps={{ paper: anchorEl ? { style: { minWidth: `${anchorEl.offsetWidth}px` } } : undefined }}
      >
        {menuItems.map((item, i) => <MenuItem onClick={handleMenuClose(item.value)} key={i}>{item.label}</MenuItem>)}
      </Menu>
    </>
  )
}